import React from 'react';
import './UserInfo.css';

const UserInfo = ({ userData, user }) => {
  return (
    <div className="user-info">
      {userData?.username && (
        <div className="username-display">
          @{userData.username}
        </div>
      )}

      <div className="info-row">
        <strong>Email:</strong> {userData?.email || user?.email}
      </div>

      <div className="info-row">
        <strong>Name:</strong> {userData?.name || user?.name}
      </div>

      {/*<div className="info-row">*/}
      {/*  <strong>Auth0 ID:</strong> {userData?.auth0_id || user?.sub}*/}
      {/*</div>*/}
    </div>
  );
};

export default UserInfo;